import { reportMetrics } from './reportMetrics';
import { pageView, flowStart } from './metrics/creates';
import { getRoute } from './route';

function getDevice() {
  if (typeof window === 'undefined') return 'unknown';
  return window.innerWidth >= 768 ? 'pc' : 'mobile';
}

function getBrowserName() {
  const ua = navigator.userAgent;
  if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  if (ua.includes('Edg')) return 'Edge';
  return 'Other';
}

function getOSName() {
  const ua = navigator.userAgent;
  if (ua.includes('Windows')) return 'Windows';
  if (ua.includes('Mac OS')) return 'macOS';
  if (ua.includes('Android')) return 'Android';
  if (ua.includes('iPhone') || ua.includes('iPad')) return 'iOS';
  if (ua.includes('Linux')) return 'Linux';
  return 'Other';
}

export function trackSession(sessionStorageKey) {
  if (typeof window === 'undefined') return;

  try {
    if (sessionStorage.getItem(sessionStorageKey) === '1') return;
    sessionStorage.setItem(sessionStorageKey, '1');
  } catch {
    return;
  }

  const device = getDevice();
  reportMetrics(
    flowStart({
      flow: 'session',
      device,
      ext1: getBrowserName(),
      ext2: getOSName(),
    }),
  );
}

function getReferrerHost() {
  if (!document.referrer) return 'direct';
  try {
    return new URL(document.referrer).hostname || 'unknown';
  } catch {
    return 'unknown';
  }
}

export function trackPageView() {
  if (typeof window === 'undefined') return;

  reportMetrics(
    pageView({
      route: getRoute(),
      device: getDevice(),
      referrer: getReferrerHost(),
    }),
  );
}
